import React, { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiOrganizationComponent } from "src/services/Api/Organization/apiOrganizationComponent";
import { JobsStatus } from "go-component/components/Job/services/types";
import { PollingAlert } from "go-component/components/PollingAlert/PollingAlert";
import { Loading } from "go-core/components/Loading";
import { useNavigationContext } from "go-core/hooks";

const { getJobsLastStatus } = apiOrganizationComponent;

export const StockStatusAlert = () => {
	const shouldSendNextRequest = useRef<boolean>(true);
	const previousJobsStatusWasStarted = useRef<boolean>(false);
	const { t } = useTranslation();
	const { isNavigationCollapsed } = useNavigationContext();

	const pollingInterval = 5000;
	const pollingFunction = useCallback(async () => {
		if (shouldSendNextRequest.current) {
			shouldSendNextRequest.current = false;
			const jobsLastStatus = await getJobsLastStatus();
			shouldSendNextRequest.current = true;
			previousJobsStatusWasStarted.current = jobsLastStatus === JobsStatus.STARTED;
		}

		return previousJobsStatusWasStarted.current;
	}, []);

	return (
		<PollingAlert pollingFunction={pollingFunction} pollingInterval={pollingInterval}>
			<span className={`stock-status-alert-content ${isNavigationCollapsed ? "small" : ""}`}>
				<Loading />
				<span>{t("components.stock_status_alert.title")}</span>
			</span>
		</PollingAlert>
	);
};
